module.exports = __webpack_public_path__ + "img/api-server.a3c79364.svg";